import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import CustomButton from '../../../shared/CustomButton';
import { FaFileExport } from 'react-icons/fa';
import { downloadFile, fetchData } from '../../../helpers/fetchData';
import i18next from 'i18next';

const ExportInvoices = ({ payload, apiUrl, exportOptionsFormat, name }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const lang = i18next.language;

  const handleExcelExport = async () => {
    setIsLoading(true);
    const response = await downloadFile('POST', apiUrl, payload, `${name}.xlsx`);
    setIsLoading(false);
    // if (!response?.data) {
    //   toast.error('No data available for export');
    //   return;
    // }
    // const exportData = exportOptionsFormat(response?.data, lang);
    // const worksheet = XLSX.utils.json_to_sheet(exportData);
    // const columnWidths = [{ wch: 15 }, { wch: 30 }, { wch: 15 }];
    // worksheet['!cols'] = columnWidths;
    // const workbook = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(workbook, worksheet, name);
    // XLSX.writeFile(workbook, `${name}.xlsx`);
  };

  return (
    <div>
      <CustomButton
        icon={<FaFileExport size={15} />}
        loading={isLoading}
        //label={t('export_to_excel')}
        title={t('export_to_excel')}
        buttonType='primary'
        onClick={handleExcelExport}
        className='!w-fit'
      />
    </div>
  );
};

export default ExportInvoices;
